import { resolveBubbleClickAction, type BubbleClickContext } from '../../../lib/bubble/drillPath';
import type { PackNode } from '../../../lib/bubble/packNodeTypes';
import type { DrillLocation, ExplorationVolume, ViewMode } from '../../../types/exploration';
import { consumeIfPanelOutsideCloseGesture } from '~/shared/utils/panelOutsideCloseGesture';

import type { BubbleRenderOptions } from './bubbleRenderOptions';

export function isBubbleNodeClickable(
  location: DrillLocation,
  view: ViewMode,
  node: PackNode,
  ctx: BubbleClickContext = {}
): boolean {
  return resolveBubbleClickAction(location, view, node, ctx).type !== 'noop';
}

export function resolveFullVolume(
  volumes: ExplorationVolume[] | undefined,
  ebsId: string
): ExplorationVolume | undefined {
  return volumes?.find((v) => v.ebsId === ebsId);
}

function resolveInstanceVolumes(
  volumes: ExplorationVolume[] | undefined,
  instanceId: string
): ExplorationVolume[] {
  return volumes?.filter((v) => v.instanceId === instanceId) ?? [];
}

export function dispatchBubbleClickAction(
  e: Event,
  node: PackNode,
  options: BubbleRenderOptions
): void {
  if (consumeIfPanelOutsideCloseGesture(e)) {
    return;
  }
  e.stopPropagation();
  const action = resolveBubbleClickAction(options.location, options.view, node, {
    secondary: options.secondary,
    tagKey: options.tagKey,
  });
  switch (action.type) {
    case 'expandOverflow':
      options.onExpandOverflow(action.parentKey);
      break;
    case 'selectVolume': {
      const volume =
        resolveFullVolume(options.volumes, action.volume.ebsId) ??
        (action.volume as ExplorationVolume);
      options.onSelectVolume(volume);
      break;
    }
    case 'selectInstance': {
      const fromOptions = resolveInstanceVolumes(options.volumes, action.instanceId);
      const vols =
        fromOptions.length > 0 ? fromOptions : (action.volumes as ExplorationVolume[]);
      if (vols.length) options.onSelectInstance(action.instanceId, vols);
      break;
    }
    case 'drill':
      options.onDrill(action.location);
      break;
    case 'drillUp':
      options.onDrillUp();
      break;
    default:
      break;
  }
}
